module.exports = __webpack_public_path__ + "img/pro_2.62636a31.jpg";